import { useEffect, useRef, useState } from 'react';

import SettingsIcon from '@/assets/all-icons/settings-icon';
import useScreenSize from '@/hooks/useScreenSize';
import useTranslations from '@/i18n/useTranslations';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import SkeletonNotification from '@/shared-components/loaders/components/SkeletonNotification';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './VirtualList';

import './styles/ProfileOverlayPopup.css';
import './styles/NotificationModal.css';

export default function NotificationModal({ open, loading, queryData, loadMoreData, showNewNotifications, close, fetch, onOpenPreferences }) {
  const t = useTranslations('common.notifications');
  const [initialLoading, setInitialLoading] = useState(true);

  const listRef = useRef();
  const screenSize = useScreenSize();

  useEffect(() => {
    if(listRef.current) {
      listRef.current.recomputeRowHeights();
    }
    
  }, [screenSize.width]);

  useEffect(() => {
    if (!loading && initialLoading) {
      setInitialLoading(false);
    }
  }, [loading, initialLoading]);

  useEffect(() => {
    if (open) {
      setInitialLoading(true);
    }
  }, [open]);

  return (
    <>
      <GenericPopup
        className="profile-overlay-popup notifications-popup"
        backgroundClassName="notifications-popup__backdrop"
        open={open}
        opacity
      >
        <div className="notifications-content__container notifications-modal__container">
          <div className="notifications-content__header notifications-modal__header">
            <button
              aria-label={t('preferences_action')}
              className="notifications-content__header-settings"
              onClick={onOpenPreferences}
              type="button"
            >
              <SettingsIcon />
            </button>
            <Text className="notifications-content__header-text">
              {t('title')}
            </Text>

            <XIcon className="notifications-content__header-close" onClick={close} />
          </div>
          <div className="notifications-modal__body">
            {initialLoading ?
              <SkeletonNotification numberOfRows={10} />
              : queryData.data?.data?.length === 0 ?
                <Text
                  className="notification-content__empty-notifications"
                  paragraph>
                  {t('empty')}
                </Text>
                :
                <VirtualList
                  key={queryData.queryString}
                  items={queryData.data}
                  onLoadMore={loadMoreData}
                  showNewNotifications={showNewNotifications}
                  fetch={fetch}
                />}
          </div>
        </div>
      </GenericPopup>
    </>
  );
}
